import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { StudioUiStateProvider } from "@/features/GenLab/components/studioUiStateContext";
import { isGenLabEnabled } from "@/features/GenLab/flag";

export const Route = createFileRoute("/_auth/genlab/$siteId")({
  beforeLoad: ({ params }) => {
    if (!isGenLabEnabled()) {
      throw redirect({
        to: "/dragon-tiles/$siteId",
        params: { siteId: params.siteId },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();

  return (
    <StudioUiStateProvider siteId={siteId}>
      <Outlet />
    </StudioUiStateProvider>
  );
}
